import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=4cd2ecd2&scoped=true"
import script from "./UserIcon.vue?vue&type=script&lang=ts"
export * from "./UserIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd2ecd2",
  null
  
)

export default component.exports